var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVignette(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0704 18.0704C19.5743 16.5664 21.8167 16 24.6769 16H31.3231C34.1833 16 36.4257 16.5664 37.9296 18.0704C39.4336 19.5743 40 21.8167 40 24.6769V31.3231C40 34.1833 39.4336 36.4257 37.9296 37.9296C36.4257 39.4336 34.1833 40 31.3231 40H24.6769C21.8167 40 19.5743 39.4336 18.0704 37.9296C16.5664 36.4257 16 34.1833 16 31.3231V24.6769C16 21.8167 16.5664 19.5743 18.0704 18.0704ZM19.3758 19.3758C18.3874 20.3641 17.8462 21.9987 17.8462 24.6769V31.3231C17.8462 34.0013 18.3874 35.6359 19.3758 36.6242C20.3641 37.6126 21.9987 38.1538 24.6769 38.1538H31.3231C34.0013 38.1538 35.6359 37.6126 36.6242 36.6242C37.6126 35.6359 38.1538 34.0013 38.1538 31.3231V24.6769C38.1538 21.9987 37.6126 20.3641 36.6242 19.3758C35.6359 18.3874 34.0013 17.8462 31.3231 17.8462H24.6769C21.9987 17.8462 20.3641 18.3874 19.3758 19.3758ZM28 30H33C33.5523 30 34 30.4477 34 31V33C34 33.5523 33.5523 34 33 34H28C27.4477 34 27 33.5523 27 33V31C27 30.4477 27.4477 30 28 30ZM25 31C25 29.3431 26.3431 28 28 28H33C34.6569 28 36 29.3431 36 31V33C36 34.6569 34.6569 36 33 36H28C26.3431 36 25 34.6569 25 33V31Z",
    fill: "#816FF6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVignette);
export default __webpack_public_path__ + "static/media/vignette.555a68a80d2c2d9794fb81ab583b1f2e.svg";
export { ForwardRef as ReactComponent };